/**
 * AnnouncementLogService
 * Service for reading announcement logs (read-only)
 */
import { BaseService } from '../base/BaseService';
/**
 * Read-only service for announcement logs
 */
export class AnnouncementLogService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementLogService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all announcement logs
     * GET /api/announcement-logs
     * @returns Array of announcement logs
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all announcement logs (raw response)
     */
    getAllRaw() {
        const url = this.buildUrl();
        return this.http.get(url);
    }
    /**
     * Get announcement log by ID
     * GET /api/announcement-logs/{id}
     * @param id - Log ID
     * @returns Announcement log entry
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Announcement log with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get announcement log by ID (raw response)
     * @param id - Log ID
     */
    getByIdRaw(id) {
        const url = this.buildUrl(String(id));
        return this.http.get(url);
    }
    /**
     * Get all logs for a specific announcement
     * GET /api/announcement-logs/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement logs
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all logs for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
}
AnnouncementLogService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementLogService.BASE_PATH = 'api/announcement-logs';
//# sourceMappingURL=AnnouncementLogService.js.map